"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TD = ({ ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTD, { ...props
});

var _default = TD;
exports.default = _default;